/**
 * Parsing methods.
 * @module parse
 */
define(function(require, exports, module, lpCoreI18n) {

    'use strict';

    /**
     * function to calculate local time
     * given the city's UTC offset
     * returns milliseconds
     */
    exports.changeTimeZoneOffset = function (timestamp, offset) {
        // create Date object for current location
        var date = new Date(timestamp);

        // convert to msec
        // add local time zone offset
        // get UTC time in msec
        var utc = date.getTime() + (date.getTimezoneOffset() * 60000);

        // create new Date object for different city
        // using supplied offset
        var dateWithOffset = new Date(utc + (3600000 * offset));
        return dateWithOffset.getTime();
    };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/modules/utils/date-conversion.js
// module id = 43
// module chunks = 0